<template>
  <div>
    <b-card no-body>
      <b-card-body v-if="!offerData.id_confirmed_user && offerData.id_purchase_offer_status !== '7' && userData.id === offerData.id_users">
        <div class="text-right">
          <b-button
            variant="primary"
            @click="modalShow()"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </div>
      </b-card-body>
      <template v-if="dataList.length > 0 ">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(title)="data">
            <div v-if="data.item.tax_number">
              <small class="text-primary">{{ data.item.tax_number }}</small>
            </div>
            {{ data.item.title }}
          </template>
          <template #cell(price)="data">
            {{ data.item.price | toCurrency }} <b class="text-primary">TL</b>
            <div v-if="data.item.confirmed_user">
              <b-badge
                variant="light-primary"
                size="sm"
              >
                <feather-icon icon="CheckIcon" />
                Onaylanan Teklif
              </b-badge>
            </div>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <b-button
                size="sm"
                variant="flat-warning"
                class="mr-1"
                @click="modalShow(data.item.id)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                size="sm"
                variant="flat-danger"
                :disabled="offerData.id_confirmed_user !== null || offerData.id_purchase_offer_status === '7' || userData.id !== offerData.id_users"
                @click="removeData(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <template v-else>
        <b-alert
          show
          variant="info"
          class="m-2"
        >
          <div class="alert-body text-center">
            <feather-icon icon="InfoIcon" />
            Eklenmiş teklif bulunmuyor.
            <div
              v-if="!offerData.id_confirmed_user && offerData.id_purchase_offer_status !== '7' && userData.id === offerData.id_users"
              class="mt-2 text-center"
            >
              <b-button
                size="sm"
                variant="primary"
                @click="modalShow()"
              >
                <feather-icon icon="PlusIcon" />
                Ekle
              </b-button>
            </div>
          </div>
        </b-alert>
      </template>
    </b-card>
    <b-modal
      v-model="modalData.status"
      title="Teklif"
      centered
      size="lg"
      no-enforce-focus
      no-close-on-esc
      no-close-on-backdrop
    >
      <template v-if="lineData.id_confirmed_user">
        <b-alert
          variant="success"
          show
          class="mt-2"
        >
          <div class="text-center alert-body">
            <feather-icon icon="InfoIcon" />
            Teklif <b>{{ lineData.confirmed_user }}</b> tarafından {{ moment(lineData.confirmed).format('DD.MM.YYYY  ') }} tarihinde onaylandı.
          </div>
        </b-alert>
      </template>
      <template v-if="offerData.id_purchase_offer_status === '7'">
        <b-alert
          variant="danger"
          show
          class="mt-2"
        >
          <div class="text-center alert-body">
            <feather-icon icon="InfoIcon" />
            Teklif Talebi <b>İptal</b> Edildi.
          </div>
        </b-alert>
      </template>
      <template v-if="modalData.step===1">
        <purchase-offers-suppliers-list-table :call-back="modalDataTypeSwitcher" />
      </template>
      <template v-if="modalData.step >=2">
        <purchase-offer-lines-item-form />
      </template>
      <template v-if="modalData.step > 2">
        <hr>
        <purchase-offer-lines-document-form />
      </template>
      <template #modal-footer>
        <template v-if="modalData.step >= 2 && !offerData.id_confirmed_user && offerData.id_purchase_offer_status !== '7' && userData.id === offerData.id_users">
          <b-button
            variant="primary"
            class="mr-3"
            size="sm"
            @click="modalData.step = 1"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Tedarikçi Seçimi
          </b-button>
        </template>
        <b-button
          variant="secondary"
          size="sm"
          @click="modalData.status=false"
        >
          <feather-icon icon="XIcon" />
          Kapat
        </b-button>
        <template v-if="modalData.step === 2">
          <b-button
            variant="primary"
            size="sm"
            @click="modalDataTypeSwitcher(lineData,2,true)"
          >
            <feather-icon icon="SaveIcon" />
            Teklifi Oluştur
          </b-button>
        </template>
        <template v-if="modalData.step === 3">
          <b-button
            v-if="!lineData.id_confirmed_user && !offerData.id_confirmed_user && offerData.id_purchase_offer_status !== '7'"
            variant="success"
            size="sm"
            :disabled="!documentsData.id"
            @click="confirmLine(lineData.id)"
          >
            <feather-icon icon="CheckIcon" />
            Teklifi Onayla
          </b-button>
          <b-button
            v-if="!offerData.id_confirmed_user && offerData.id_purchase_offer_status !== '7' && userData.id === offerData.id_users"
            variant="primary"
            size="sm"
            @click="modalDataTypeSwitcher(lineData,3,true)"
          >
            <feather-icon icon="SaveIcon" />
            Kaydet
          </b-button>
        </template>

      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BAlert, BModal, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PurchaseOffersSuppliersListTable from '@/views/Admin/Purchase_offers/Components/SuppliersListTable.vue'
import PurchaseOfferLinesItemForm from '@/views/Admin/Purchase_offers/Components/OfferLineItemData.vue'
import PurchaseOfferLinesDocumentForm from '@/views/Admin/Purchase_offers/Elements/Lines/DocumentForm.vue'

const tableName = 'purchase_offer_lines'
export default {
  name: 'PurchaseOfferLinesTable',
  components: {
    PurchaseOfferLinesDocumentForm,
    PurchaseOfferLinesItemForm,
    PurchaseOffersSuppliersListTable,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BAlert,
    BModal,
    BBadge,
  },
  props: {
    refeshData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      modalData: {
        status: false,
        step: 1,
      },
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'price',
          label: 'Tutar',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.odate AS odate`,
          `${tableName}.price AS price`,
          `${tableName}.confirmed AS confirmed`,
          `${tableName}.created AS created`,
          'suppliers.company AS title',
          'confirmed_user.name AS confirmed_user',
        ],
        limit: this.$store.state.app.perPage,
        where: {
          'purchase_offer_lines.id_purchase_offers': this.$route.params.id,
        },
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOfferLines/dataList']
    },
    lineData() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
    offerData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
    dataCounts() {
      return this.$store.getters['purchaseOfferLines/dataCounts']
    },
    documentsData() {
      return this.$store.getters['purchaseOfferDocuments/dataItem']
    },
    saveData() {
      return this.$store.getters['purchaseOfferLines/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    // this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('purchaseOfferLines/getDataList', this.dataQuery)
    },
    modalShow(id) {
      if (id) {
        this.modalData.step = 3
        this.$store.commit('purchaseOfferDocuments/RESET_DATA_ITEM')
        this.$store.dispatch('purchaseOfferLines/getDataItem', { id })
          .then(res => {
            if (res) {
              this.$store.dispatch('purchaseOfferDocuments/getDataItem2', id)
                .then(doc => {
                  if (!doc) {
                    this.$store.commit('purchaseOfferDocuments/RESET_DATA_ITEM')
                  }
                })
              this.modalData.status = true
            }
          })
      } else {
        this.modalData.step = 1
        this.$store.commit('purchaseOfferLines/RESET_DATA_ITEM')
        this.$store.commit('purchaseOfferDocuments/RESET_DATA_ITEM')
        this.modalData.status = true
      }
    },
    modalDataTypeSwitcher(item, step, submit = false) {
      if (step === 1) {
        this.modalData.step = 2
        this.lineData.id_suppliers = item.id
        this.lineData.suppliers = item.title
      }
      if (step >= 2 && submit) {
        if (this.lineData.price && this.lineData.odate) {
          this.lineData.id_purchase_offers = this.$route.params.id
          this.$store.dispatch('purchaseOfferLines/saveData', this.lineData)
            .then(res => {
              if (res.status) {
                this.modalData.step = 3
                this.$store.dispatch('purchaseOfferLines/getDataItem', { id: res.id })
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'İşlem Başarısız',
                  text: res.message ? res.message : 'Teknik hata sebebi ile işlem başarısız.',
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        } else {
          this.$swal({
            icon: 'error',
            title: 'İşlem Başarısız',
            text: 'Lütfen teklif tutarı ve tarihi alanlarını doldurunuz',
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('purchaseOfferLines/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    confirmLine(id) {
      this.$swal({
        title: 'Teklif Onayla',
        text: 'Seçtiğiniz teklifi onaylamak istiyor musunuz?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('purchaseOfferLines/confirmOffer', id)
            .then(res => {
              if (res.status) {
                this.$swal({
                  icon: 'success',
                  title: 'Teklif Onaylandı!',
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refeshData()
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'İşlem Başarısız',
                  text: res.message ? res.message : 'Teknik hatadan dolayı işlem başarısız.',
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
